import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { applicationSettingSchema } from '../schemas/application-setting.schema';

/**
 * Gets the account's application settings
 * @param accountAlias alias of the account
 * @param applicationId ID of application
 * @returns application settings array
 */
export function getAccountsApplicationSettings(
  this: unknown,
  accountAlias: string,
  applicationId: number
) {
  const params = new URLSearchParams([
    ['accountAlias', accountAlias],
    ['applicationId', String(applicationId)],
  ]);

  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).accountsApplicationSettingsUrl
      }?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(applicationSettingSchema)));
}
